module.exports = {
  other: [48, 70, 150, 310],
  favicons: [96, 32, 16, 128, 196],
  appleIcons: [57, 60, 72, 76, 114, 120, 144, 152]
};
